export const INIT_SIGN_UP = 'INIT_SIGN_UP';
export const SIGN_UP = 'SIGN_UP';
export const SIGN_UP_FULFILLED = 'SIGN_UP_FULFILLED';
export const SIGN_UP_REJECTED = 'SIGN_UP_REJECTED';

export const SEND_SIGN_UP_EMAIL = 'SEND_SIGN_UP_EMAIL';
export const SEND_SIGN_UP_EMAIL_FULFILLED = 'SEND_SIGN_UP_EMAIL_FULFILLED';
export const SEND_SIGN_UP_EMAIL_REJECTED = 'SEND_SIGN_UP_EMAIL_REJECTED';
